export const urlsApisPortal = Object.freeze({
	API_CONSULTA_ENTIDADE: "/api-consulta-entidade/consulta-entidade",
});

export const urlsApis = Object.freeze({
	API_FGTAS: "/api-fgtas",
});
